(function () {
  'use strict';

  function initSwipers() {
    document.querySelectorAll('[data-product-swiper]').forEach((el) => {
      if (el._swiperInit) return;
      el._swiperInit = true;
      new Swiper(el, {
        loop: true,
        autoplay: { delay: 3000, disableOnInteraction: false },
        pagination: {
          el: el.querySelector('[data-swiper-pagination]'),
          clickable: true,
        },
      });
    });
  }

  function initSwatches() {
    document.querySelectorAll('[data-swatch-group]').forEach((group) => {
      if (group._swatchInit) return;
      group._swatchInit = true;

      const firstActive = group.querySelector('.product-card__swatch--active');
      if (firstActive) {
        firstActive.style.setProperty('--swatch-active-color', firstActive.style.backgroundColor);
      }

      group.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-swatch-value]');
        if (!btn) return;

        group.querySelectorAll('[data-swatch-value]').forEach((swatchBtn) => {
          swatchBtn.classList.remove('product-card__swatch--active');
          swatchBtn.setAttribute('aria-pressed', 'false');
          swatchBtn.style.removeProperty('--swatch-active-color');
        });
        btn.classList.add('product-card__swatch--active');
        btn.setAttribute('aria-pressed', 'true');
        btn.style.setProperty('--swatch-active-color', btn.style.backgroundColor);

        const newSrc            = btn.dataset.swatchImage;
        const newVariantId      = btn.dataset.variantId;
        const newCompareAtPrice = btn.dataset.compareAtPrice;
        const card              = btn.closest('[data-product-card]');
        if (!card) return;

        const atcBtn = card.querySelector('[data-atc-btn]');
        if (atcBtn && newVariantId) {
          atcBtn.dataset.variantId      = newVariantId;
          atcBtn.dataset.compareAtPrice = newCompareAtPrice || '0';
        }

        const regularPriceEl    = card.querySelector('[data-product-price-regular]');
        const salePriceEl       = card.querySelector('[data-product-price-sale]');
        const comparePriceEl    = card.querySelector('[data-product-price-compare]');

        const newPriceText = btn.dataset.price;
        const comparePriceText = btn.dataset.compareAtPrice;

        const newPriceNum = parseInt(btn.dataset.priceRaw || '0', 10);
        const compareAtPriceNum = parseInt(btn.dataset.compareAtPriceRaw || '0', 10);

        if (regularPriceEl || salePriceEl) {
          if (compareAtPriceNum > newPriceNum) {
            if (salePriceEl) {
              salePriceEl.textContent = newPriceText;
              salePriceEl.hidden = false;
            }
            if (comparePriceEl) {
              comparePriceEl.textContent = comparePriceText;
              comparePriceEl.hidden = false;
            }
            if (regularPriceEl) regularPriceEl.hidden = true;
          } else {
            if (regularPriceEl) {
              regularPriceEl.textContent = newPriceText;
              regularPriceEl.hidden = false;
            }
            if (salePriceEl) salePriceEl.hidden = true;
            if (comparePriceEl) comparePriceEl.hidden = true;
          }
        }

        const swiperEl = card.querySelector('[data-product-swiper]');
        if (newSrc) {
          if (swiperEl && swiperEl.swiper) {
            const activeSlide = swiperEl.swiper.slides[swiperEl.swiper.activeIndex];
            const activeImg = activeSlide?.querySelector('img');
            if (activeImg) activeImg.src = newSrc;
          } else {
            const primaryImg = card.querySelector(
              '.product-card__img--primary, .product-card__img'
            );
            if (primaryImg) primaryImg.src = newSrc;
          }
        }

      });
    });
  }

  async function fetchCartState() {
    const res = await fetch(window.Shopify.routes.root + 'cart.js');
    if (!res.ok) throw new Error('Cart fetch failed');
    return res.json();
  }

  function applyCompareAtToCart(cart, variantId, compareAtPrice) {
    const compareAt = Number(compareAtPrice || 0);
    if (!cart || !Array.isArray(cart.items) || !variantId || !compareAt) return cart;
    cart.items.forEach((item) => {
      const itemVariantId = item.variant_id || item.id;
      const finalPrice    = Number(item.final_price || item.price || 0);
      if (String(itemVariantId) !== String(variantId) || compareAt <= finalPrice) return;
      item._compareAtPrice     = compareAt;
      item._compareAtLinePrice = compareAt * Math.max(1, Number(item.quantity || 1));
    });
    return cart;
  }

  async function syncCartUI(cart) {
    if (!cart) return null;
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.classList.toggle('cart-count--hidden', cart.item_count === 0);
    });
    document.querySelectorAll('[data-cart-count-label]').forEach((el) => {
      el.textContent = '(' + cart.item_count + ')';
    });
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.refresh === 'function') {
      await cartDrawer.refresh(cart);
    }
    return cartDrawer;
  }

  function initATCButtons() {
    document.querySelectorAll('[data-atc-btn]').forEach((btn) => {
      if (btn._atcInit) return;
      btn._atcInit = true;

      if (btn.dataset.cartType === 'page') {
        btn.addEventListener('click', async (e) => {
          e.preventDefault();
          const variantId      = btn.dataset.variantId;
          const compareAtPrice = btn.dataset.compareAtPrice;
          if (!variantId || btn.disabled) return;
          btn.classList.add('product-card__atc-btn--loading');
          try {
            const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: variantId, quantity: 1 }),
            });
            if (!res.ok) throw new Error('Add to cart failed');
            const cart = await fetchCartState();
            applyCompareAtToCart(cart, variantId, compareAtPrice);
            await syncCartUI(cart);
            window.location.href = window.Shopify.routes.root + 'cart';
          } catch (err) {
            console.error('[ProductCard ATC page]', err);
            btn.classList.remove('product-card__atc-btn--loading');
          }
        });
        return;
      }

      btn.addEventListener('click', async () => {
        const variantId      = btn.dataset.variantId;
        const compareAtPrice = btn.dataset.compareAtPrice;
        if (!variantId || btn.disabled) return;
        btn.classList.add('product-card__atc-btn--loading');
        btn.disabled = true;
        try {
          const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          });
          if (!res.ok) throw new Error('Add to cart failed');
          await res.json();
          const cart       = await fetchCartState();
          applyCompareAtToCart(cart, variantId, compareAtPrice);
          const cartDrawer = await syncCartUI(cart);
          btn.classList.remove('product-card__atc-btn--loading');
          btn.classList.add('product-card__atc-btn--success');
          if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
          setTimeout(() => {
            btn.classList.remove('product-card__atc-btn--success');
            btn.disabled = false;
          }, 500);
        } catch (err) {
          console.error('[ProductCard ATC]', err);
          btn.classList.remove('product-card__atc-btn--loading');
          btn.disabled = false;
        }
      });
    });
  }

  window.ProductCard = {
    fetchCartState,
    applyCompareAtToCart,
    syncCartUI
  };

  function init() {
    initSwipers();
    initSwatches();
    initATCButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();